import React, {Component} from 'react'
import Slide from '../Globals/Slide/slide'
import './estilo.css'
import * as XLSX from 'xlsx';
import InfiniteCalendar from 'react-infinite-calendar';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import {RadioGroup, Radio} from 'react-radio-group'
 

class CargarEmple extends Component{
    constructor(props){
        super(props);
        this.state={
            eventos:[],
            event:[], 
            contador:0,
            auxiliar:0, 
            isLoading:true,
            fechEx:'',
            template:false,
            isNull:false,
            guardados:0,
            isGuardando:false,
            tipoV:'Base',
        }
    }


    procesar = (event) =>{
        
        try
        {
            var file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = (event) => {
                /* Parse data */
                const bstr = event.target.result;
                const wb = XLSX.read(bstr, {type:'binary'});
                /* Get first worksheet */
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                /* Convert array of arrays */
                const data =XLSX.utils.sheet_to_json(ws,{header:"A"});
                /* Update state */
                let datos =[];
                let fecha =''
                data.forEach(element => {
                    if(element.C!==undefined){
                        let dataFech = element.C.split(" ");  
                        fecha = new Date(dataFech[0]);

                        datos.push(element);
                    }
                });
                this.setState({event:datos, isLoading:false, fechEx:fecha});
            };
            reader.readAsBinaryString(file);
        }
        catch(error){

        }
    }


    selecionSalida = (event) =>{
        this.setState({tipoV: event});
    }


    asociarDato = () =>{
        let valorEspe = this.state.event.length;
        if(this.state.event.length != 0 )
        {
            this.comprobar(false);
        }
        else{
            Alert.error('Proporcione una planificacion para continuar', {
                effect: 'genie',
                position: 'bottom-right',
                timeout:2000			
            });
        }
    }

    comprobar(tipo){
        let nombreV = '';
        let tama = this.state.event.length;
        let inicio = 1;
        let holi =0;
        let nombreE='';
        let vueloN='';
        let repetidos=0;
        let isGuardando=false;
        this.state.event.map(element => {
            if(element.C!==undefined)
            {
                let dataFech = element.C.split(" ");  
                let fecha = (tipo===false?new Date(dataFech[0]):new Date(this.state.fechaSele));
                let fecha2 = new Date(dataFech[0]);
                firebase.database().ref().child('Programacion').orderByChild('vuelo').equalTo(element.A).once("value").then(snapshot =>
                {
                    let data = snapshot.val();
                    if(snapshot.val()!== null)
                    {         
                        firebase.database().ref('Programacion/'+snapshot.node_.children_.root_.key+'/frecuencia').once('value').then(snap =>{
                            let valor = 0;
                            let contador=0;
                            let valorE = Object.keys(snap.val()).length;
                            snap.forEach(element2 => {
                                let comprar = element2.val();
                                let fechaB = new Date(comprar.valor);
                                if(fechaB.getTime() === fecha.getTime())
                                { 
                                    contador = contador+1;
                                    valor = 1;
                                    isGuardando=true;
                                    firebase.database().ref().child('Clientes').orderByChild('numero_empleado').equalTo(element.F).once('value').then(result =>
                                    {  
                                        if(result.val()!== null)
                                        {
                                            let codiU = result.node_.children_.root_.key + snapshot.node_.children_.root_.key + element2.key + dataFech[1]+element.I;
                                            firebase.database().ref().child('ProgramacionDia').orderByChild('codiUni').equalTo(codiU).once('value').then(hijo =>
                                            {
                                                if(hijo.val() !== null)
                                                {
                                                    this.setState({contador:(this.state.contador+1)});
                                                    repetidos = repetidos + 1;
                                                }
                                                else{
                                                    this.setState({contador:(this.state.contador+1), auxiliar:(this.state.auxiliar+1),guardados:(this.state.guardados+1)})
                                                    firebase.database().ref().child('ProgramacionDia').push({
                                                        emple:result.node_.children_.root_.key , 
                                                        idP:snapshot.node_.children_.root_.key, 
                                                        idH:element2.key,
                                                        hora:dataFech[1], 
                                                        dhpax:element.B===undefined?'':element.B,
                                                        rango:element.D,
                                                        escala:element.E, 
                                                        obser:element.G===undefined?'':element.G, 
                                                        centroC:element.H,
                                                        codiUni:codiU,
                                                        estado:'Pendiente',
                                                        tipo:'estandar',
                                                        motiCanc:'',
                                                        base:element.I,
                                                    });
                                                }
                                            });
                                        }
                                        else{
                                            nombreE = nombreE + element.F + ', ';
                                            this.setState({contador:(this.state.contador+1)})
                                        }
                                    });
                                }
                                else{
                                    contador= contador+1;
                                    if(fechaB.getTime() === fecha2.getTime())
                                    {
                                        valor = 1;
                                        this.setState({contador:(this.state.contador+1), auxiliar:(this.state.auxiliar+1), isNull:true})
                                    }
                                    else{
                                        if(contador===valorE)
                                        {
                                            if(valor === 0){                                              
                                                    vueloN = vueloN + element.A + ', ';
                                                    this.setState({contador:(this.state.contador+1)})
                                            }
                                        }
                                    }
                                }
                            });
                        })
                    }
                    else{
                        nombreV = nombreV + element.A + ', ';
                        this.setState({contador:(this.state.contador+1)})
                    }
                });
                setTimeout(() => {  
                    if(this.state.contador === tama)
                    {   
                        if(this.state.auxiliar === this.state.contador)
                        {
                            if(this.state.isNull === false)
                            {
                                Alert.success('Se han ingresado '+this.state.auxiliar+' registros satisfactoriamente', {
                                    effect: 'genie',
                                    position: 'bottom-right',
                                    timeout:null,
                                    html:true			
                                });
                                this.setState({contador:0, auxiliar:0,guardados:0})
                            }else{
                                if(isGuardando===true)
                                {
                                    setTimeout(() => {
                                        Alert.warning('Se han guardado '+this.state.guardados+' registros el resto de viajes no se han podido asiganar debido a falta de itinararios disponibles en esta fecha', {
                                            effect: 'genie',
                                            position: 'bottom-right',
                                            timeout:null,
                                            html:true,
                                            limit:1			
                                        });
                                        this.setState({contador:0, auxiliar:0,isNull:false,guardados:0})
                                    }, 1000);
                                }
                                else{
                                    Alert.error('No se encontro una planificacion asociada para ninguno de los vuelos contenidos en el Excel para este dia', {
                                        effect: 'genie',
                                        position: 'bottom-right',
                                        timeout:null,
                                        html:true			
                                    });
                                }
                                this.setState({contador:0, auxiliar:0,isNull:false,guardados:0})
                            }
                        }
                        else{
                            if(this.state.isNull === false)
                            {
                                if(nombreV!==''){
                                    Alert.warning('Se han ingresado '+this.state.auxiliar+'/'+this.state.contador+' registros satisfactoriamente, favor comprobar en el excel que los nombres de los vuelos: '+nombreV + 'concuerden con los ingresados en el sistema', {
                                        effect: 'genie',
                                        position: 'bottom-right',
                                        timeout:null,
                                        html:true			
                                    });
                                }
                                if(nombreE!==''){
                                    Alert.warning('Se han ingresado '+this.state.auxiliar+'/'+this.state.contador+' registros satisfactoriamente, favor comprobar en el excel que los codigo de empleado: '+nombreE + 'concuerden con los ingresados en el sistema', {
                                        effect: 'genie',
                                        position: 'bottom-right',
                                        timeout:null,
                                        html:true		
                                    });
                                }
                                if(repetidos>0)
                                {
                                    Alert.warning('Se han ingresado '+this.state.auxiliar+'/'+this.state.contador+' registros satisfactoriamente, debido a que '+repetidos+' registros ya estan dentro de la planificación', {
                                        effect: 'genie',
                                        position: 'bottom-right',
                                        timeout:null,
                                        html:true		
                                    });
                                }
                                if(vueloN!==''){
                                    Alert.warning('Se han ingresado '+this.state.auxiliar+'/'+this.state.contador+' registros satisfactoriamente, favor verificar que el/los vuelos '+vueloN+ ' tengan planificacion asignada a este dia', {
                                        effect: 'genie',
                                        position: 'bottom-right',
                                        timeout:null,
                                        html:true		
                                    });
                                }
                                this.setState({contador:0, auxiliar:0,guardados:0})
                            }else{
                                if(isGuardando===true)
                                {
                                    setTimeout(() => {
                                        Alert.warning('Se han guardado '+this.state.guardados+' registros el resto de viajes no se han podido asiganar debido a falta de itinararios disponibles en esta fecha', {
                                            effect: 'genie',
                                            position: 'bottom-right',
                                            timeout:null,
                                            html:true,
                                            limit:1			
                                        });
                                        this.setState({contador:0, auxiliar:0,isNull:false,guardados:0})
                                    }, 1000);
                                }
                                else{
                                    Alert.error('No se encontro una planificacion asociada para ninguno de los vuelos contenidos en el Excel para este dia', {
                                        effect: 'genie',
                                        position: 'bottom-right',
                                        timeout:null,
                                        html:true			
                                    });
                                }
                                this.setState({contador:0, auxiliar:0,isNull:false,guardados:0})
                            }
                        }
                    } 
                }, 1000);
            }
        });
    } 

    render(){
        let {isLoading} = this.state;
        return(
        <div>
            <div className='borde'>
                    <div className="row">
                        <aside  className="col-sm-12" onClick={this.mensual} style={{ marginTop:50}}>
                            <div className="form-group" style={{height:150}} className='centro'>
                                <div className="row">
                                    <div className="custom-file">
                                        <label className="custom-file-label" for="customFile">Choose file</label>
                                        <input type="file" className="custom-file-input" id="customFile" onChange={this.procesar}/>
                                    </div>
                                </div>
                            <div className="row">
                            </div>
                            </div>
                            {isLoading === true &&
                                <button  type="button" disabled={this.state.isLoading} className="btn btn-info pull-right">Ingresar</button>
                            }
                            {isLoading === false &&
                                <button onClick={()=>this.asociarDato()}  type="button" className="btn btn-info pull-right">Ingresar</button>
                            }
                        </aside>
                    </div>
            </div>
        </div>
        );
    }
}
export default CargarEmple;


// WEBPACK FOOTER //
// ./src/Components/Programacion/cargaEmple.js